import { Button } from "semantic-ui-react";
import {flattenNestedRecords} from "../../utils/exportUtils";
import {getDepositData} from "../../utils/cdpDepositUtils";

function arrayToCSV2(data) {
  const header = Object.keys(data[0]);
  const headerString = header.join(",");
  const rowItems = data.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName])).join(","));
  return [headerString, ...rowItems].join("\r\n");
}

const downloadCSV = (data, filename) => {
  const csvData = arrayToCSV2(data);
  try {
    let link = document.createElement("a");
    link.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(csvData));
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.warn(err);
  }
};

const ExportCdpReport = (props) => {
  const { records, collectionsData, scheduleHours, getPracticeName } = props;

  const handleDownload = () => {
    // Build canonical deposit maps (sum per ukgid) so CSV uses source-of-truth
    try {
      const firstEntries = getDepositData(records, "first", props.startDate, false) || [];
      const secondEntries = getDepositData(records, "second", props.startDate, false) || [];
      const sumByUkgid = (entries) =>
        entries.reduce((acc, e) => {
          const id = String(e.ukgid || "");
          acc[id] = (acc[id] || 0) + Number(e.amount || 0);
          return acc;
        }, {});
      const firstByUkgid = sumByUkgid(firstEntries);
      const secondByUkgid = sumByUkgid(secondEntries);

      // Create enriched records that use canonical deposit totals when available
      const enrichedRecords = (records || []).map((r) => ({
        ...r,
        firstDeposit: r.ukgid && firstByUkgid[r.ukgid] !== undefined ? firstByUkgid[r.ukgid] : r.firstDeposit,
        secondDeposit: r.ukgid && secondByUkgid[r.ukgid] !== undefined ? secondByUkgid[r.ukgid] : r.secondDeposit,
      }));

      const flatRecords = flattenNestedRecords(enrichedRecords, collectionsData, scheduleHours, getPracticeName);
      downloadCSV(flatRecords, "cdp_reports.csv");
      return;
    } catch (err) {
      console.warn("Failed to compute canonical deposits for CSV export, falling back to raw records", err);
    }

    // Fallback to original behavior if anything goes wrong
    const flatRecords = flattenNestedRecords(records, collectionsData, scheduleHours, getPracticeName);
    downloadCSV(flatRecords, "cdp_reports.csv");
  };

  return (
    <Button className={"float-left"} onClick={handleDownload}>
      Export to CSV
    </Button>
  );
};

export default ExportCdpReport;
